var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextSteps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(0 -143.956)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1135",
    "data-name": "Rectangle 1135",
    width: 32,
    height: 32,
    transform: "translate(0 143.956)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4567",
    "data-name": "Path 4567",
    d: "M351.743,159.956l-4.575-6.4h-6.113l4.575,6.4-4.575,6.4h6.113Z",
    transform: "translate(-319.743 0)",
    fill: "#09c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4568",
    "data-name": "Path 4568",
    d: "M218.479,159.956l-4.575-6.4h-6.018l4.575,6.4-4.575,6.4H213.9Z",
    transform: "translate(-194.896 0)",
    fill: "#09c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4569",
    "data-name": "Path 4569",
    d: "M15.262,159.956l-4.575-6.4H0v12.81H10.687ZM9.69,158.409l-3.758,4.177-2.841-2.615,1.27-1.379,1.446,1.331,2.49-2.768Z",
    transform: "translate(0 0)",
    fill: "#09c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextSteps);
export default __webpack_public_path__ + "static/media/next-steps.49e3525ee6b179f4df1128bdf648c095.svg";
export { ForwardRef as ReactComponent };